import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface OnboardingPopupState {
  isIntersectingWithOtherPopups: boolean;
  isOpen: boolean;
  setIsIntersectingWithOtherPopups: (isIntersectingWithOtherPopups: boolean) => void;
  setIsOpen: (isOpen: boolean) => void;
  setWasClosed: (wasClosed: boolean) => void;
  wasClosed: boolean;
}

export const useOnboardingPopupStore = create<OnboardingPopupState>()(
  persist(
    (set) => ({
      isOpen: false,
      wasClosed: false,
      isIntersectingWithOtherPopups: false,
      setIsOpen: (isOpen: boolean) => set({ isOpen }),
      setIsIntersectingWithOtherPopups: (isIntersectingWithOtherPopups: boolean) =>
        set({ isIntersectingWithOtherPopups }),
      setWasClosed: (wasClosed: boolean) => set({ wasClosed }),
    }),
    {
      name: 'onboarding-popup',
    },
  ),
);
